/**
 * Generate a W3C traceparent header value.
 * Format: 00-{32 hex trace-id}-{16 hex span-id}-01
 * Uses crypto.getRandomValues; guards against all-zero IDs.
 */
export function generateTraceparent(): string {
  const buf = new Uint8Array(24); // 16 bytes trace-id + 8 bytes span-id
  crypto.getRandomValues(buf);
  if (buf.every((b) => b === 0)) buf[0] = 1;
  const hex = Array.from(buf, (b) => b.toString(16).padStart(2, "0")).join("");
  const traceId = hex.slice(0, 32);
  const spanId = hex.slice(32, 48);
  return `00-${traceId}-${spanId}-01`;
}
